<div class="well col-lg-6 col-lg-offset-3">
    <vue-label i18nBundle="Connect" labelKey="message.NotAuthorizedForSiteAffiliate"></vue-label>
</div>
